import React from 'react'
import styles from './copyRightFooter.module.scss'
import { FormattedMessage } from 'react-intl'

export default function CopyRightFooter() {
  return (
    <div className={styles.copyRightFooter}>
      <div className={styles.copyRightFooter_wrapper}>
        {`\u00A9 ${new Date().getFullYear()} `}
        <span className={styles.text}>
          <FormattedMessage id="rodi_motor_services" />
        </span>
      </div>
    </div>
  )
}
